module.exports = __webpack_public_path__ + "img/tuandui.0a58bb89.png";